var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 19.1148C40 8.55898 31.0446 0 20 0C8.95536 0 0 8.55898 0 19.1148C0 28.6551 7.3125 36.563 16.875 37.9983V24.6418H11.7955V19.1148H16.875V14.9035C16.875 10.1138 19.8616 7.46585 24.4295 7.46585C26.6179 7.46585 28.9071 7.83962 28.9071 7.83962V12.5441H26.3839C23.9009 12.5441 23.1241 14.0169 23.1241 15.5308V19.1148H28.6705L27.7848 24.6418H23.125V38C32.6875 36.5655 40 28.6577 40 19.1148Z",
    fill: "#F1E1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f6949ebf6b0d4fe01fe772844c68bb79.svg";
export { ForwardRef as ReactComponent };